import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '../repository';
import { KC_COLORS } from '../theme';
import { resolveKcArticleImage } from './kcArticleImages';
import { KC_TRUNCATE, truncateAtWord } from '../truncateAtWord';

export function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles();

  return (
    <div className="kc-featured-articles h-full min-h-0 flex flex-col" style={{ textAlign: 'left' }}>
      <div
        className="flex items-center justify-between gap-3 mb-5 shrink-0"
        style={{ textAlign: 'left' }}
      >
        <h2
          className="kc-section-title kc-type-h3 uppercase tracking-[0.08em] m-0"
          style={{ color: KC_COLORS.primaryNavy, textAlign: 'left' }}
        >
          Featured Articles
        </h2>
        <a
          href="#kc-categories"
          className="kc-type-body font-semibold no-underline whitespace-nowrap"
          style={{ color: KC_COLORS.teal }}
        >
          View all articles →
        </a>
      </div>

      <div className="flex-1 min-h-0 flex flex-col gap-4">
        {featuredArticles.map((article) => {
          const imageSrc = resolveKcArticleImage(article.imageKey);

          return (
            <Link
              key={article.id}
              to={article.path}
              className="kc-featured-card group flex flex-1 flex-col sm:flex-row gap-4 sm:gap-5 rounded-2xl border bg-white p-3.5 sm:p-4 no-underline transition-all duration-300 ease-out hover:-translate-y-0.5 hover:shadow-[0_12px_28px_rgba(10,29,58,0.12)]"
              style={{ borderColor: KC_COLORS.border, textAlign: 'left' }}
            >
              <div
                className="relative w-full sm:w-[148px] md:w-[160px] h-[132px] sm:h-auto sm:min-h-[132px] rounded-xl overflow-hidden shrink-0"
                style={{ backgroundColor: KC_COLORS.primaryNavy }}
              >
                {imageSrc ? (
                  <img
                    src={imageSrc}
                    alt=""
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.04]"
                  />
                ) : (
                  <div
                    className="absolute inset-0 opacity-40"
                    style={{
                      background:
                        'radial-gradient(circle at 30% 40%, #009BAA 0%, transparent 55%), radial-gradient(circle at 70% 70%, #3B82F6 0%, transparent 50%)',
                    }}
                    aria-hidden
                  />
                )}
              </div>

              <div
                className="flex flex-1 flex-col min-w-0 py-0.5 pr-1 items-start"
                style={{ textAlign: 'left' }}
              >
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mb-2">
                  <span
                    className="kc-type-caption font-bold tracking-[0.06em] uppercase"
                    style={{ color: KC_COLORS.teal }}
                  >
                    {article.tag}
                  </span>
                  <span
                    className="inline-flex items-center gap-1 kc-type-caption font-medium"
                    style={{ color: KC_COLORS.gray600 }}
                  >
                    <AccessTimeOutlinedIcon
                      sx={{ fontSize: 14, color: KC_COLORS.teal }}
                    />
                    {article.readTime}
                  </span>
                </div>

                <h3
                  className="m-0 mb-2 w-full transition-colors duration-200"
                  style={{
                    color: KC_COLORS.primaryNavy,
                    fontSize: '18px',
                    lineHeight: '26px',
                    fontWeight: 600,
                    textAlign: 'left',
                  }}
                >
                  {article.title}
                </h3>

                {article.summary ? (
                  <p
                    className="m-0 w-full kc-listing-summary"
                    style={{
                      color: KC_COLORS.gray600,
                      fontSize: '14px',
                      lineHeight: '22px',
                      textAlign: 'left',
                    }}
                  >
                    {truncateAtWord(article.summary, KC_TRUNCATE.threeLines)}
                  </p>
                ) : null}

                <span
                  className="mt-3 inline-flex items-center gap-1 font-semibold transition-all duration-200 group-hover:gap-2"
                  style={{
                    color: KC_COLORS.teal,
                    fontSize: '14px',
                    lineHeight: '20px',
                  }}
                >
                  Read article
                  <ArrowForwardRoundedIcon sx={{ fontSize: 16 }} />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
